// Helper compartido para descargar un CSV desde datos ya calculados en memoria.
// No le pega al servidor: arma el archivo con lo que recibe y lo baja.
//
// columnas: [{ key, label, format? }]
// filas:    array de objetos
// nombre:   nombre del archivo (sin extension)

const escapar = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v);
  // Si trae coma, comilla o salto de linea, se encierra en comillas.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export function descargarCsv(columnas, filas, nombre) {
  const head = columnas.map((c) => escapar(c.label)).join(",");
  const body = filas.map((row) =>
    columnas
      .map((c) => {
        const val = c.format ? c.format(row[c.key], row) : row[c.key];
        return escapar(val);
      })
      .join(","),
  );
  // BOM para que Excel respete acentos/UTF-8.
  const contenido = "\uFEFF" + [head, ...body].join("\n");
  const blob = new Blob([contenido], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${nombre}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
